import { render, staticRenderFns } from "./AcceptRejectRequest.vue?vue&type=template&id=ccdd2ab2&scoped=true"
import script from "./AcceptRejectRequest.vue?vue&type=script&lang=js"
export * from "./AcceptRejectRequest.vue?vue&type=script&lang=js"
import style0 from "./AcceptRejectRequest.vue?vue&type=style&index=0&id=ccdd2ab2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccdd2ab2",
  null
  
)

export default component.exports